import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { CreateAdditionalAccount } from '@webapp/store/user/action-creators';
import {
  CREATE_ADDITIONAL_ACCOUNT,
  CREATE_ADDITIONAL_ACCOUNT_ERROR,
} from '@webapp/store/user/actions';

import Box from '@components/layout/box';
import InputField from '@components/form/input';
import BoxHeader from '@components/layout/box-header';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

import ButtonLoadingFixedCtrl from '@webapp/controllers/button-loading-fixed';

import { Translate } from 'react-localize-redux';

const mapStateToProps = (state: AppState) => ({
  isLoading: !!state.ui.loading[CREATE_ADDITIONAL_ACCOUNT],
  errorMsg: state.ui.errors[CREATE_ADDITIONAL_ACCOUNT_ERROR],
});

interface ConfirmChangesPageProps {
  isLoading: boolean;
  createAccount: (password: string) => CreateAdditionalAccount;
  className?: string;
  errorMsg?: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createAccount: (password: string) =>
    dispatch(new CreateAdditionalAccount(password)),
});

export const ConfirmChangesPage: React.FC<ConfirmChangesPageProps> = (
  props
) => {
  const [password, setPassword] = React.useState('');
  const { isLoading, createAccount, errorMsg } = props;
  const [error, setError] = React.useState<string>();

  const handleSubmit = React.useCallback(() => {
    if (password) {
      setError('');
      createAccount(password);
    } else {
      setError('You should enter a password');
    }
  }, [password, createAccount]);

  return (
    <MotionOpacity>
      <Typography className="mb-20" type="subheader" weight="400"></Typography>
      <Box>
        <BoxHeader
          title={<Translate id="USER_PROFILE.GENERAL.EMAIL.CONFIRM.TITLE" />}
          text={<Translate id="USER_PROFILE.GENERAL.EMAIL.CONFIRM.TEXT" />}
        />
        <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
          <InputField
            className="mb-15"
            name="password"
            error={
              error || errorMsg === 'UsernameExistsException' ? (
                <Translate id={`APIError.ConfirmPage.${errorMsg}`} />
              ) : (
                errorMsg
              )
            }
            label={<Translate id="USER_PROFILE.GENERAL.EMAIL.CONFIRM.INPUT" />}
            autoComplete="off"
            type="password"
            value={password}
            onChange={setPassword}
          />
        </form>
      </Box>
      <ButtonLoadingFixedCtrl
        isLoading={isLoading}
        small
        onClick={handleSubmit}
      >
        <Translate id="USER_PROFILE.GENERAL.EMAIL.CONFIRM.BTN" />
      </ButtonLoadingFixedCtrl>
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ConfirmChangesPage)`
  margin-bottom: 100px;
  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 0;
  }
`);
